module["exports"] = [
  "Taiwan (R.O.C.)"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/zh_TW/address/default_country.js
// module id = 1698
// module chunks = 0